import { useQuery } from 'react-query'
import { apiJSON } from '@shared/utils/api/api.util'
import { Status } from '@shared/types'

export function useStatusesQuery() {
  const { isLoading: areStatusesLoading, data: statuses } = useQuery<Status[]>(
    `statuses`,
    () => apiJSON(`statuses`)
  )

  return { statuses, areStatusesLoading }
}
